import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { initTelegram, getColorScheme, getThemeParams } from './lib/telegram';
import './i18n';
import './index.css';

// Init Telegram WebApp
initTelegram();

// Apply Telegram theme to CSS vars (опционально — основной UI всё равно тёмный)
const scheme = getColorScheme();
const params = getThemeParams();
if (scheme === 'light' && params.bg_color) {
  document.documentElement.style.setProperty('--vst-bg', params.bg_color);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 30,
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
